import { render, staticRenderFns } from "./DeviceConfig.vue?vue&type=template&id=70f461c6&scoped=true&"
import script from "./DeviceConfig.vue?vue&type=script&lang=js&"
export * from "./DeviceConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f461c6",
  null
  
)

export default component.exports